var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewGradientStar = function SvgReviewGradientStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#895FFC",
    fillRule: "evenodd",
    d: "M24.35 6.01c.205-.632 1.1-.632 1.306 0l4.56 14.033h14.753c.666 0 .942.851.404 1.242l-11.936 8.672 4.559 14.032c.206.633-.519 1.16-1.057.768l-11.936-8.672-11.937 8.672c-.538.391-1.262-.135-1.057-.768l4.56-14.032-11.937-8.672c-.538-.39-.261-1.242.404-1.242H19.79z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#review-gradient-star_svg__a)",
    fillOpacity: 0.9,
    fillRule: "evenodd",
    d: "M24.35 6.01c.205-.632 1.1-.632 1.306 0l4.56 14.033h14.753c.666 0 .942.851.404 1.242l-11.936 8.672 4.559 14.032c.206.633-.519 1.16-1.057.768l-11.936-8.672-11.937 8.672c-.538.391-1.262-.135-1.057-.768l4.56-14.032-11.937-8.672c-.538-.39-.261-1.242.404-1.242H19.79z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "review-gradient-star_svg__a",
    x1: 19,
    x2: 53.5,
    y1: -1,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })))));
};
export default SvgReviewGradientStar;